// Copyright (c) 2017 Comsearch, Inc., All rights reserved

/* eslint-disable quotes */

import XRegExp from 'xregexp'

export const alphanumeric = /^[a-z0-9]+$/i
// allows for decimal and negative values
// does not allow scientific notation eg. "1e4"
export const numericalValuesOnly = /^[+-]?((\.\d+)|(\d+(\.(\d+)?)?))$/
export const goodProjectName = /^[a-z0-9 _#&()\-/]+$/i
export const goodPathOrSiteName = goodProjectName

export const validAntennaCode = /^[a-z0-9*]{1,6}$/gi
export const validRadioCode = /^[a-z0-9#]{1,6}$/gi
export const validFavoriteRadioCode = /^[a-z0-9#]{1,6}-\d+$/gi

// taken from https://emailregex.com/
// this regex breaks an eslint rule however for consistency in front and back ends of the Lego application,
// the regex used in both code bases are the same.
// eslint-disable-next-line no-control-regex
export const validEmail = /^(?:[a-z0-9!#$%&''*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&''*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i

// all acceptable formats of DMS coords
// DD MM SS.SS N/S, DDD MM SS.SS E/W
// +/- DD MM SS.SS, +/- DDD MM SS.SS
export const coordsDMS = XRegExp(
  `^(?<prefix> [-]{0,1}|[NnEeSsWw][\\s])\n\
  (?<degrees>  [0-9]{1,3}) (\\s|-|°|°\\s|\\s°\\s)\n\
  (?<minutes>  [0-9]{1,2}) (\\s|-|'|'\\s|’|’\\s)\n\
  (?<seconds>  [0-9]{1,2}([.]{1}[0-9]{0,2})?) ["]{0,1}[\\s]{0,1}\n\
  (?<suffix>   [NnEeSsWw]{0,1})\n$`, `x`
)

// all acceptable formats of DD coords
// DD.DDDDDD N/S, DD.DDDDDD E/W
// +/- DD.DDDDDD, +/- DD.DDDDDD
// NOTE: the line:
//      (?<decimal>  [0-9]{0,12}) [\\s]{0,1}\n\
// means that this regex allows for values which have more than 6 decimals.
// eg. 32.1234567890574 vs 32.123456
// this is so that we can gracefully handle when such a value is given
// (this could be from API or from user input.)
// however we will still only consider the first six decimal places
// which are included in the ?<degrees> match.
export const coordsDD = XRegExp(
  `^(?<prefix> ([-]{0,1}|[NnEeSsWw][\\s]))\n\
  (?<degrees>  [0-9]{1,3}([.]{1}[0-9]{0,6})?)\n\
  (?<decimal>  [0-9]{0,15}) [\\s]{0,1}\n\
  (?<suffix>   [NnEeSsWw]{0,1})\n$`, `x`
)

export const dateFormat = XRegExp(
  `^(?<year>  [0-9]{4})[/]\n\
  (?<month>  [0-9]{2})[/]\n\
  (?<day>   [0-9]{2})\n$`, `x`
)

export const fccDateFormat = XRegExp(
  `^(?<month>  [0-9]{2})[/]\n\
  (?<day>   [0-9]{2})[/]\n\
  (?<year>  [0-9]{4})\n$`, `x`
)

// escapes common special characters for regex.
// this is specifically for strings that contain *
// without this, those strings would break the constructor
export const escapeForRegEx = s => (
  s.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
)

// dynamically generates wildcards to support query % wildcards
// so "b%lb" --> /^b.*lb.*$/, matches "billboard"
// NOTE: wild cards are added to the end of the string always
// so if the input's value is "b%lb%" or "b%lb" it will return the same results.
export const createRegExpWithWildcards = s => (
  new RegExp(`^${escapeForRegEx(s).toLowerCase().replace(/%/g, '.*')}.*$`)
)
